module.exports = __webpack_public_path__ + "static/media/logo-secran.cfb26028.svg";